import { render, staticRenderFns } from "./customerController.vue?vue&type=template&id=1a6aa9c6&"
import script from "./customerController.vue?vue&type=script&lang=js&"
export * from "./customerController.vue?vue&type=script&lang=js&"
import style0 from "./customerController.vue?vue&type=style&index=0&id=1a6aa9c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports